import "./index.less"
import "./indexMobile.less"
import {useNavigate} from "react-router-dom";
import {isMobile} from "react-device-detect";

export default ({url, text, style, onClick}) => {
    const navigate = useNavigate();

    return <>

        {!isMobile && <div className={"moreButton"} style={style} onClick={() => {
            if (url) {
                navigate(url);
            }

            if (onClick) {
                onClick();
            }
        }}>
            <div className={"icon"}>
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8.5 0.0147705L9.29759 5.98488C9.41708 6.8793 10.1207 7.58293 11.0151 7.70242L16.9853 8.50005L11.0151 9.29759C10.1207 9.41708 9.41708 10.1207 9.29758 11.0151L8.5 16.9853L7.70242 11.0151C7.58292 10.1207 6.87929 9.41708 5.98485 9.29759L0.0147188 8.50005L5.98488 7.70242C6.8793 7.58293 7.58292 6.8793 7.70241 5.98488L8.5 0.0147705Z"
                        fill="white"/>
                </svg>
            </div>

            <div className={"text"}>
                {text ? text : "查看更多"}
            </div>
        </div>}

        {isMobile && <div className={"moreButton-mobile"} style={style} onClick={() => {
            if (url) {
                navigate(url);
            }

            if (onClick) {
                onClick();
            }
        }}>
            <div className={"icon-mobile"}>
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8.5 0.0147705L9.29759 5.98488C9.41708 6.8793 10.1207 7.58293 11.0151 7.70242L16.9853 8.50005L11.0151 9.29759C10.1207 9.41708 9.41708 10.1207 9.29758 11.0151L8.5 16.9853L7.70242 11.0151C7.58292 10.1207 6.87929 9.41708 5.98485 9.29759L0.0147188 8.50005L5.98488 7.70242C6.8793 7.58293 7.58292 6.8793 7.70241 5.98488L8.5 0.0147705Z"
                        fill="white"/>
                </svg>
            </div>

            <div className={"text-mobile"}>
                {text ? text : "查看更多"}
            </div>
        </div>}

    </>
}